import Vue from 'vue';
import { mapGetters } from 'vuex';

Vue.mixin({
  computed: {
    ...mapGetters(['search/locale']),
    uppercaseLocale() {
      return this['search/locale'].toUpperCase();
    },
    isMobileDevice() {
      return window.screen.width < 768;
    },
  },
});
